import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { ActivatedRoute, Router } from "@angular/router";
import { SessionService } from "../../services/session.service";
import { environment } from "../../../environments/environment";
import Swal from "sweetalert2";
import { Md5 } from "ts-md5/dist/md5";
import { Ng4LoadingSpinnerService } from "ng4-loading-spinner";
import { UtilityService } from "src/app/services/utility.service";
import { SharedService } from "src/app/services/shared.service";

@Component({
  selector: "app-employees",
  templateUrl: "./employees.component.html",
  styleUrls: ["./employees.component.scss"],
})
export class EmployeesComponent implements OnInit {
  apiUrl: string;
  addEmployeeForm: FormGroup;
  searchForm: FormGroup;
  dtOptions: any = {};
  submitted = false;
  collectionCenterEmployees: any = {};

  config: any;
  currentPageLength: any = 10;
  searchObject: any = {};

  employee: any;
  employeeSingleResponse: any;
  updateemployeeId: any;
  isDisabled: boolean = false;
  isEdit: boolean = false;

  applicationId: any;
  private_laboratory_appId: any;

  constructor(
    private formBuilder: FormBuilder,
    private http: HttpClient,
    private router: Router,
    private route: ActivatedRoute,
    private utility: UtilityService,
    private sess: SessionService,
    private spinnerService: Ng4LoadingSpinnerService,
    public shared: SharedService
  ) {}

  ngOnInit(searchObj = null) {
    this.sess.checkLogin();

    this.applicationId = localStorage.getItem("application_id");
    this.private_laboratory_appId = environment.APP_ID_PRIVATE_LABORATORY;
    this.sess.confirmUser(
      this.applicationId,
      this.private_laboratory_appId,
      "Private Laboratory"
    );

    if (searchObj == null || searchObj == "") {
      this.collectionCenterEmployees = "";
      this.initialiseForm();
      this.initTable();
      console.log("searchObj is null");
    } else {
      this.collectionCenterEmployees = "";
      console.log("searchObj is not null");
    }

    /* Pagination Start */
    this.config = {
      currentPage: 1,
      itemsPerPage: 10,
    };

    this.getCollectionCenterEmployees(
      this.config.itemsPerPage,
      this.config.currentPage
    );

    this.route.queryParams.subscribe(
      (params) =>
        (this.config.currentPage = params["page"] ? params["page"] : 1)
    );
    this.shared.getCollectionCentersList();
  }

  initialiseForm() {
    this.addEmployeeForm = this.formBuilder.group({
      name: [
        "",
        [
          Validators.required,
          Validators.maxLength(45),
          Validators.pattern("^[A-Za-z 0-9 _-]*[A-Za-z0-9][A-Za-z0-9 _]*$"),
        ],
      ],
      emailAddress: [
        "",
        [
          Validators.required,
          Validators.maxLength(45),
          Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$"),
        ],
      ],
      phoneNumber: [
        "",
        [
          Validators.required,
          Validators.pattern(/^[0][1-9]\d{9}$|^[1-9]\d{9}$/),
          Validators.minLength(11),
          Validators.maxLength(11),
        ],
      ],
      contactAddress: ["", [Validators.required]],
      collectionCenter: ["", [Validators.required]],
      status: ["", [Validators.required]],
    });

    this.searchForm = this.formBuilder.group({
      employee_name: [""],
      employee_phone: [""],
      employee_email: [""],
    });
  }

  initTable() {
    this.dtOptions = {
      paging: false,
      pagingType: "full_numbers",
      responsive: true,
      pageLength: 10,
      lengthChange: false,
      processing: false,
      ordering: false,
      info: false,
      columnDefs: [
        {
          //targets: [ 10 ],
          visible: false,
          searchable: false,
        },
      ],
      dom:
        "<'row'<'col-sm-4'l><'col-sm-4 text-center'B><'col-sm-4'f>>" +
        "<'row'<'col-sm-12'tr>>" +
        "<'row'<'col-sm-5'i><'col-sm-7'p>>",
      buttons: [
        // { extend: 'csv',   className: 'btn btn-outline-dark', text: '<i class="fas fa-file-csv"> CSV</i>', exportOptions: {columns: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10]}},
        // { extend: 'excel', className: 'btn btn-outline-dark', text: '<i class="fas fa-file-excel"> Excel</i>', exportOptions: {columns: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10]} },
        // { extend: 'pdf',   className: 'btn btn-outline-dark', text: '<i class="fas fa-file-pdf"> PDF</i>' , orientation: 'landscape', pageSize: 'LEGAL', exportOptions: {columns: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10]}},
        // { extend: 'print', className: 'btn btn-outline-dark', text: '<i class="far fas fa-print"> Print</i>', exportOptions: {columns: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10] } }
      ],
    };
  }

  onSubmitEmployee(formData) {
    this.submitted = true;

    if (this.addEmployeeForm.invalid) {
      return;
    }

    var requestObj = {
      name: formData.name,
      email: formData.emailAddress,
      phone: formData.phoneNumber,
      address: formData.contactAddress,
      center_id: formData.collectionCenter,
      status: formData.status == "Active" ? true : false,
    };

    this.apiUrl = environment.AUTHAPIURL + "collection-center-employee/add";
    if (this.isEdit) {
      requestObj["id"] = this.updateemployeeId;
      this.apiUrl =
        environment.AUTHAPIURL + "collection-center-employee/update";
    }

    this.spinnerService.show();

    const reqHeader = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: "Bearer " + localStorage.getItem("access_token"),
    });

    this.http
      .post<any>(this.apiUrl, requestObj, { headers: reqHeader })
      .subscribe((data) => {
        // console.log("apiResponse: ", data);
        this.spinnerService.hide();

        if (data.status == true) {
          Swal.fire({
            icon: "success",
            title: "Success",
            text: data.message,
            showConfirmButton: true,
            timer: 5000,
          });

          this.ngOnInit();
          this.utility.closeAllModals();
        } else {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            html: this.shared.getErrorMessage(data),
            // text: data.message,
            showConfirmButton: true,
            timer: 5000,
          });
        }
      });
  }

  viewAddEmployee(modal) {
    this.utility.showModal(modal);
  }

  getCollectionCenterEmployees(perpage, pageno) {
    this.spinnerService.show();

    this.apiUrl =
      `${environment.AUTHAPIURL}collection-center-employee/list?page=` + pageno;

    this.searchObject["page_no"] = pageno;
    this.searchObject["per_page"] = perpage;
    this.searchObject["application_id"] =
      localStorage.getItem("application_id");
    this.searchObject["role_id"] = localStorage.getItem("role_id");

    const reqHeader = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: "Bearer " + localStorage.getItem("access_token"),
    });

    this.http
      .post<any>(this.apiUrl, this.searchObject, { headers: reqHeader })
      .subscribe((data) => {
        this.spinnerService.hide();
        if (data.status == true) {
          this.collectionCenterEmployees = data.response.data;
          this.config.totalItems = data.response.total;
        } else {
          Swal.fire({
            icon: "info",
            title: "Oops...",
            text: data.message,
            showConfirmButton: true,
            timer: 5000,
            timerProgressBar: true,
          });
        }
      });
  }

  pageChange(newPage: number) {
    this.collectionCenterEmployees = "";
    this.router.navigate(["/employees"], {
      queryParams: { page: newPage },
    });
    this.getCollectionCenterEmployees(this.config.itemsPerPage, newPage);
  }

  public setItemsPerPage(event) {
    this.config.itemsPerPage = event;
    this.currentPageLength = this.config.itemsPerPage;
    this.collectionCenterEmployees = "";
    this.router.navigate(["/employees"]);
    this.getCollectionCenterEmployees(this.config.itemsPerPage, 1);
  }

  onSubmitSearch(formAllData: any) {
    this.submitted = true;

    // stop the process here if form is invalid
    if (this.searchForm.invalid) {
      return;
    }

    this.searchObject = {
      name: formAllData.employee_name,
      phone: formAllData.employee_phone,
      email: formAllData.employee_email,
    };

    console.log("searchFormData: ", this.searchObject);
    this.collectionCenterEmployees = "";
    this.getCollectionCenterEmployees(
      this.config.itemsPerPage,
      this.config.currentPage
    );
  }

  clearSearch() {
    this.collectionCenterEmployees = "";
    this.searchObject = {};
    this.initialiseForm();
    this.getCollectionCenterEmployees(
      this.config.itemsPerPage,
      this.config.currentPage
    );
  }
  showEditEmployee(employee, modal) {
    this.spinnerService.show();
    this.submitted = false;
    this.isDisabled = true;
    this.employee = employee;
    this.apiUrl =
      `${environment.AUTHAPIURL}collection-center-employee/` + this.employee.id;

    const reqHeader = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: "Bearer " + localStorage.getItem("access_token"),
    });

    this.http
      .get<any>(this.apiUrl, { headers: reqHeader })
      .subscribe((data) => {
        console.log("Single Employee Details: ", data);
        this.employeeSingleResponse = data.response;
        this.spinnerService.hide();

        this.addEmployeeForm.controls["name"].setValue(
          this.employeeSingleResponse.name
        );
        this.addEmployeeForm.controls["emailAddress"].setValue(
          this.employeeSingleResponse.email
        );
        this.addEmployeeForm.controls["phoneNumber"].setValue(
          this.employeeSingleResponse.phone
        );
        this.addEmployeeForm.controls["contactAddress"].setValue(
          this.employeeSingleResponse.address
        );
        this.addEmployeeForm.controls["collectionCenter"].setValue(
          this.employeeSingleResponse.center_id
        );
        this.addEmployeeForm.controls["status"].setValue(
          this.employeeSingleResponse.status ? "Active" : "Inactive"
        );

        this.updateemployeeId = this.employee.id;
        this.utility.openModal(modal);
      });
  }

  showDetails(employee, modal) {
    this.spinnerService.show();
    this.submitted = false;
    this.employee = employee;
    this.apiUrl =
      `${environment.AUTHAPIURL}collection-center-employee/` + this.employee.id;

    const reqHeader = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: "Bearer " + localStorage.getItem("access_token"),
    });

    this.http
      .get<any>(this.apiUrl, { headers: reqHeader })
      .subscribe((data) => {
        console.log(data);
        this.employeeSingleResponse = data.response;
        this.employeeSingleResponse.profile_image =
          this.employeeSingleResponse.profile_image ??
          "https://via.placeholder.com/100";
        this.spinnerService.hide();
        this.utility.openModal(modal);
      });
  }
}
